import React from 'react';
import { NavLink } from 'react-router-dom';

const Footer = (props) => {
  return (
    <section className='pb-4 '>
      <div className='container'>
        <div className='row'>
          <div className='partners-sec no-border'>
            <div className=' d-flex flex-wrap flex-lg-nowrap partners'>
              <a
                className='partner-list'
                target='_blank'
                href='https://eeas.europa.eu/delegations/georgia_en'
                rel='noreferrer'
              >
                <img src='../../images/banner1.png' alt='' />
              </a>
              <a
                className='partner-list'
                target='_blank'
                href='https://www.eastern-partnership.ptb.de/home/'
                rel='noreferrer'
              >
                <img src='../../images/banner2.png' alt='' />
              </a>
              <a
                className='partner-list'
                target='_blank'
                href='https://www.prosafe.org/'
                rel='noreferrer'
              >
                <img src='../../images/banner3.png' alt='' />
              </a>
            </div>
          </div>

          <div className='partners-sec'>
            <div className=' d-flex flex-wrap flex-lg-nowrap align-items-center  partners'>
              <a className='partner-list' href='https://rs.ge'>
                <img src='../../images/8.png' alt='' />
              </a>
              <a className='partner-list' href='https://www.economy.ge/'>
                <img src='../../images/1.png' alt='' />
              </a>
              <a
                className='partner-list'
                href='http://www.dcfta.gov.ge/en/home'
              >
                <img src='../../images/3.png' alt='' />
              </a>
              <a className='partner-list' href='https://gac.gov.ge/ge'>
                <img src='../../images/5.png' alt='' />
              </a>
              <a className='partner-list' href='https://www.matsne.gov.ge/'>
                <img src='../../images/7.png' alt='' />
              </a>
              <a className='partner-list' href='https://geostm.ge/'>
                <img src='../../images/6.png' alt='' />
              </a>
            </div>
          </div>
        </div>

        <hr className='hr' />

        <div className='row'>
          <div className='col-md-3 mb-4 mb-md-0 col-md-4'>
            <img
              className='footer-logo'
              src='../../images/main-black.png'
              alt=''
            />
          </div>
          <div className='col-6 col-md-2 mb-4 mb-md-0'>
            <h5 className='semi-bold font__size--18 text__14-1024 text-uppercase mb-3'>
              ბმულები
            </h5>

            <ul className='wrapper__list-footer'>
              <li>
                <NavLink
                  to='/faq'
                  className='semi-bold font__size--16 text__14 color__black text-uppercase '
                >
                  FAQ
                </NavLink>
              </li>

              <li>
                <NavLink
                  to='/contact'
                  className='semi-bold font__size--16 text__14 color__black text-uppercase '
                >
                  კონტაქტი
                </NavLink>
              </li>
            </ul>
          </div>
          <div className='col-6 col-md-3 mb-4 mb-md-0'>
            <div>
              <h5 className='semi-bold font__size--18 text__14-1024 text-uppercase mb-3'>
                სოციალური ქსელები:
              </h5>

              <div className='d-flex align-items-center'>
                <a
                  href='https://www.facebook.com/profile.php?id=61556200025406'
                  target='blanck'
                >
                  <img src='../../images/FB.png' alt='' />
                </a>
                {/* <a href='#!' className='mx-3'>
                  <img src='../../images/IG.png' alt='' />
                </a> */}
                <a href='tel:1483' style={{ marginLeft: 15 }}>
                  <img src='../../images/WA.png' alt='' />
                </a>
              </div>
            </div>

            <div className='mt-5'>
              <h5 className='semi-bold font__size--18 text__14-1024 text-uppercase mb-3'>
                დაგვიკავშირდით
              </h5>
              <div className='d-flex align-items-center mb-3'>
                <img src='../../images/Message.png' alt='' />
                <span className='semi-bold font__size--16 text__14-1024 ml-2'>
                  info@msa.gov.ge
                </span>
              </div>
              <div className='d-flex align-items-center'>
                <img src='../../images/Call.png' alt='' />
                <span className='semi-bold font__size--14 text__14 text-uppercase ml-2'>
                  14 83
                </span>
              </div>
            </div>
          </div>
          <div className='col-md-3 mb-4 mb-md-0'>
            <h5 className='semi-bold font__size--18 text__14-1024 text-uppercase mb-3'>
              გამოიწერეთ სიახლეები
            </h5>

            <input
              type='text'
              className='form-control wrapper__field roboto normal font__size--16 text__16-1024 mb-3'
              placeholder='ელ.ფოსტის მისამართი'
              name=''
              id=''
            />
            <button className='semi-bold font__size--14 text__14-1024 color__white text-uppercase btn btn__blue shadow rounded-0'>
              გამოწერა
            </button>
          </div>
        </div>
        <div className='text-center normal roboto font__size--16 text__16-1024 color__gray-1 mt-5'>
          2025 ყველა უფლება დაცულია, ბაზარზე ზედამხედველობის სააგენტო
        </div>
      </div>
    </section>
  );
};

export default Footer;
